import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GenericTable } from '../interfaces/table';
import { UserProjectControllerApi } from '../sdk-api/api/userProjectController.service';
import { Configuration } from '../sdk-api/configuration';
import { ProjectFilter1 } from '../sdk-api/model/projectFilter1';
import { ProjectWithRelations } from '../sdk-api/model/projectWithRelations';
import { UserProjectWithRelations } from '../sdk-api/model/userProjectWithRelations';
import { BASE_PATH } from '../sdk-api/variables';
import { AuthenticatedUser } from './authenticated-user.service';

@Injectable({
  providedIn: 'root',
})
export class UserProjectService extends UserProjectControllerApi {
  constructor(
    protected authenticatedUser: AuthenticatedUser,
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    super(httpClient, basePath, configuration);
  }

  findForTable(filter: ProjectFilter1): Observable<ProjectTable> {
    return this.userProjectFind(filter).pipe(
      map((response) => ({
        data: response,
        count: response.length,
      })),
    );
  }

  userProjectFind(filter: ProjectFilter1): Observable<ProjectWithRelations[]> {
    const { id: userId } = this.authenticatedUser.user;
    return this.userProjectControllerFind(
      userId,
      JSON.stringify(filter) as unknown,
    );
  }

  userProjectPersonalFind(): Observable<ProjectWithRelations> {
    const filter = {
      where: {
        studyType: ProjectWithRelations.StudyTypeEnum.NUMBER_3 as never,
      },
    };

    return this.userProjectFind(filter).pipe(map((projects) => projects[0]));
  }

  userProjectFindById(projectId: string): Observable<ProjectWithRelations> {
    const { id: userId } = this.authenticatedUser.user;
    return this.userProjectControllerFindById(userId, projectId);
  }

  loadProjectPermission(
    configuration: Partial<UserProjectWithRelations>,
  ): void {
    const { role } = configuration;

    this.authenticatedUser.loadPermissions(role);
  }

  loadStaffProjectPermission(): void {
    this.authenticatedUser.loadPermissions(
      UserProjectWithRelations.RoleEnum.Staff.toLowerCase(),
    );
  }
}

export type ProjectTable = GenericTable<ProjectWithRelations>;
